import ZJApp from '../'

export default ZJApp;